import { AdTimer } from "./utils/AdTimer";

import { GameConstants } from "./GameConstants";

export enum WhyCallAd {
    onClickRetry,
    onClickHome,
    onGameStart,
    onClickLevelSelection
}

export class SponsorManager {

    public static adFilter(f: Function, game: Phaser.Game, whyCallAd: WhyCallAd): void {

        if (!AdTimer.timeForAd()) {
            f();
            return;
        }

        let onFinished: Function = () => {
            game.paused = false;
            game.sound.mute = false;
            f();
        };

        game.paused = true;
        game.sound.mute = true;

        if (GameConstants.SPONSOR === GameConstants.SPONSOR_YANDEX) {

            switch (whyCallAd) {
                case WhyCallAd.onClickLevelSelection:
                case WhyCallAd.onClickRetry:
                case WhyCallAd.onClickHome:
                case WhyCallAd.onGameStart:
                    {
                        try {
                            ysdk.adv.adv = { onAdvClose: onFinished };
                            ysdk.adv.showFullscreenAdv();
                        } catch (e) {
                            console.warn("ysdk undefined");
                            onFinished();
                        }
                        break;
                    }
                default:
                    onFinished();
                    break;
            }
        } else {
            onFinished();
        }
    }
}
